import { Dialog } from "primereact/dialog";

import { SingleStepModalProps } from "interfaces";

export const SingleStepDialog = ({
  body,
  footer,
  display,
  header,
  setVisible,
  isDismissable = true,
  onHideCallback,
  size = "lg",
  height,
  width,
  minHeight,
  customClass,
  maxWidth,
  action,
}: SingleStepModalProps) => {
  return (
    <Dialog
      id="single-step-dialog"
      dismissableMask={isDismissable}
      className={`modal-${size} ${customClass}`}
      icons={action}
      draggable={false}
      resizable={false}
      header={header}
      footer={footer}
      visible={display}
      style={{
        height: height,
        width: width,
        minHeight: minHeight,
        maxWidth: maxWidth,
      }}
      onHide={() => (onHideCallback ? onHideCallback() : setVisible(false))}
    >
      {body}
    </Dialog>
  );
};
